/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';

import { NumberField as BaseNumberField } from '@base-ui/react/number-field';

import { UIcon } from 'shared-ui/uicon';

import styles from './NumberField.module.scss';

interface NumberFieldProps extends React.ComponentProps<typeof BaseNumberField.Root> {
    'aria-label': string;
    isFullWidth?: boolean;
}

export function NumberField({
    'aria-label': ariaLabel,
    className,
    max = 99,
    isFullWidth = false,
    ...props
}: NumberFieldProps) {
    return (
        <BaseNumberField.Root className={className} max={max} {...props}>
            <BaseNumberField.Group className={styles.Group}>
                <BaseNumberField.Decrement className={styles.Decrement}>
                    <UIcon name="minus" size={16} />
                </BaseNumberField.Decrement>
                <BaseNumberField.Input
                    style={
                        {
                            '--number-field-chars': max.toString().length,
                        } as React.CSSProperties
                    }
                    className={cx(styles.Input, { [styles.fullWidth]: isFullWidth })}
                    aria-label={ariaLabel}
                />
                <BaseNumberField.Increment className={styles.Increment}>
                    <UIcon name="plus" size={16} />
                </BaseNumberField.Increment>
            </BaseNumberField.Group>
        </BaseNumberField.Root>
    );
}
